import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Edit, Trash2 } from 'lucide-react';

/**
 * Owner action dropdown — edit / delete + approval-status indicator.
 * Visible only to the business owner; positioned absolutely under the
 * Business header.
 */
export function BusinessOwnerMenu({
    isOpen,
    entityLabel,
    approved,
    onEdit,
    onDelete,
    menuRef,
}) {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    ref={menuRef}
                    initial={{ opacity: 0, scale: 0.94, y: -12 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.94, y: -12 }}
                    transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
                    className="absolute top-20 right-6 bg-surface rounded-xl shadow-elevated z-floating overflow-hidden border border-line-subtle min-w-[220px]"
                >
                    <div className="bg-surface-muted px-4 py-3 border-b border-line-subtle">
                        <p className="eyebrow text-brand-700">ניהול {entityLabel}</p>
                    </div>

                    <motion.button
                        type="button"
                        whileHover={{ x: 4 }}
                        className="w-full py-3 px-4 hover:bg-surface-muted transition-colors flex items-center gap-3 border-b border-line-subtle group"
                        onClick={onEdit}
                    >
                        <div className="w-9 h-9 rounded-lg bg-brand-50 group-hover:bg-brand-100 text-brand-700 flex items-center justify-center transition-colors">
                            <Edit className="w-4 h-4" strokeWidth={2} />
                        </div>
                        <span className="text-sm font-semibold text-ink">ערוך {entityLabel}</span>
                    </motion.button>

                    <motion.button
                        type="button"
                        whileHover={{ x: 4 }}
                        className="w-full py-3 px-4 hover:bg-danger-50 transition-colors flex items-center gap-3 border-b border-line-subtle group"
                        onClick={onDelete}
                    >
                        <div className="w-9 h-9 rounded-lg bg-danger-50 group-hover:bg-danger-100 text-danger-600 flex items-center justify-center transition-colors">
                            <Trash2 className="w-4 h-4" strokeWidth={2} />
                        </div>
                        <span className="text-sm font-semibold text-danger-700">מחק {entityLabel}</span>
                    </motion.button>

                    <div className="py-3 px-4 bg-surface-muted flex items-center gap-3">
                        <span className={`w-2.5 h-2.5 rounded-pill ${approved ? 'bg-success-500' : 'bg-warning-500'} animate-pulse`} aria-hidden="true" />
                        <span className="text-xs font-semibold text-ink-muted">
                            {approved ? 'פעיל' : 'ממתין לאישור'}
                        </span>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default BusinessOwnerMenu;
